<template>
  <MonitoringDashboard />
</template>

<script>
import MonitoringDashboard from './components/HelloWorld.vue';

export default {
  name: 'AppRoot',
  components: {
    MonitoringDashboard
  }
};
</script>

<style>
:root {
  --screen_background: #071018;
  --panel_background: rgba(8, 18, 28, 0.92);
  --panel_shadow: 0 14px 30px rgba(0, 0, 0, 0.28);
  --panel_highlight: inset 0 1px 0 rgba(132, 186, 214, 0.04);
  --text_primary: #e6edf4;
  --text_secondary: #7f93a6;
  --text_muted: #607487;
  --accent_cyan: #4fc2dc;
  --accent_teal: #5fd0a5;
  --accent_gold: #d2a655;
  --accent_red: #d27b78;
}

* {
  box-sizing: border-box;
}

html,
body,
#app {
  width: 100%;
  min-height: 100%;
  margin: 0;
}

body {
  background:
    radial-gradient(circle at 50% -18%, rgba(36, 112, 146, 0.12), transparent 28%),
    linear-gradient(180deg, #04090f 0%, #071018 48%, #03070c 100%);
  color: var(--text_primary);
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  overflow-x: hidden;
}

body::before {
  content: "";
  position: fixed;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(113, 187, 214, 0.014) 1px, transparent 1px),
    linear-gradient(90deg, rgba(113, 187, 214, 0.014) 1px, transparent 1px);
  background-size: 72px 72px;
  opacity: 0.08;
}
</style>
